export const styles = theme => ({
  root: {
    outline: 'none',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    fontSize: theme.constants.fontSizes.regular,
    cursor: 'pointer',
  },
});
